import React from 'react'

const Copyright = () => (
  <div>
    Fotos &copy; Jana Forkmann.
  </div>
)

export default Copyright
